module.exports = __webpack_public_path__ + "components/flag/static/square/cl-7d680659f14e3063bff3c34c9c86356e.svg";